import script from "./BudgetSummaryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BudgetSummaryCard.vue?vue&type=script&setup=true&lang=ts"

import "./BudgetSummaryCard.vue?vue&type=style&index=0&id=5ab194f5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ab194f5"]])

export default __exports__